import api from "@/services/packages.js";
export default {
  namespaced: true,
  state() {
    return {
      packages: [],
      loading: true,
      pagination: {
        page: 1,
        page_size: 10,
      },
    };
  },
  mutations: {
    set_packages(state, { data }) {
      state.pagination = data.pagination;
      state.packages = data.rows;
      state.loading = false;
    },
    set_new(state, data) {
      state.packages.push(data);
      // console.log(state.packages);
      // state.loading = false;
    },
    set_package_null(state) {
      state.packages = [];
      state.loading = false;
    },
  },
  getters: {
    // employees(state) {
    //   return state.employees;
    // },
    loading(state) {
      return state.loading;
    },
  },
  actions: {
    list({ dispatch, commit }, filter) {
      return new Promise(async (resolve, reject) => {
        await api
          .list(filter)
          .then((res) => {
            commit("set_packages", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err)
            commit("set_package_null");
            dispatch("api/handleServiceException", { e: err }, { root: true });
          });
      });
    },
    addOne({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api
          .add(payload)
          .then((res) => {
            dispatch("api/handleServiceException", { e: res }, { root: true });
            commit("set_new", res.data);
            resolve(res);
          })
          .catch((err) => {
            dispatch("api/handleServiceException", { e: err }, { root: true });
            reject(res);
          });
      });
    },
    set_status({ state }, data) {
      try {
        // console.log(" status ", status);
        var foundIndex = state.packages.findIndex((x) => x.id == data.id);
        state.packages[foundIndex].status = data.status;
        state.packages[foundIndex].did = data.did;
        state.packages[foundIndex].access_group = data.access_group;
      }
      catch (e) {

      }
    },
    pushNewpackage({ commit }, data) {
      // console.log(" status ", data);
      try {
        // console.log(" status ", status);
        var foundIndex = state.packages.findIndex((x) => x.id == data.id);
        state.packages[foundIndex].status = data.status;
        state.packages[foundIndex].did = data.did;
        state.packages[foundIndex].access_group = data.access_group;
      }
      catch (e) {
        commit("set_new", data);
      }



    },
    deleteOne({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api
          .delete(payload)
          .then((res) => {
            dispatch("api/handleServiceException", { e: res }, { root: true });
            resolve(res);
          })
          .catch((err) => {
            dispatch("api/handleServiceException", { e: err }, { root: true });
            reject(res);
          });
      });
    },
  },
};
